export default __webpack_public_path__ + "static/risk-insight-template-e4da0ad51de83d7beb0c261958cf8ab4.svg";